var map = {
	"./Boy-1.png": "3443",
	"./Boy-2.png": "080b",
	"./Boy-3.png": "7383",
	"./Dog-1.png": "1e69",
	"./Dog-2.png": "11c1",
	"./Dog-3.png": "9917",
	"./GlassesMan-1.png": "5a74",
	"./GlassesMan-2.png": "c1f5",
	"./GlassesMan-3.png": "2438",
	"./Skateboard-1.png": "3ba9",
	"./Skateboard-2.png": "0680",
	"./Skateboard-3.png": "cfe8",
	"./bg.png": "f0e4",
	"./black-1.png": "2cd8",
	"./black-2.png": "b915",
	"./black-3.png": "23e5",
	"./close_btn.png": "3e87",
	"./container.png": "c493",
	"./correct_box.png": "cb3e",
	"./girl-1.png": "8044",
	"./girl-2.png": "5f98",
	"./girl-3.png": "1cef",
	"./header.png": "390b",
	"./timer.png": "93df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e4a";